const React = require('react');

const Name = require('./Name.jsx');

const Utilities = {
    Config: {
        Id: {
            DocumentSettings: 'documentSettings'
        },
        checkVisibility: function (props, name) {
            if (!props) {
                return false;
            }
            return props.builder || props.forceVisibility || Utilities.Config.getVisibility(props.config, name);
        },
        findBlockConfig: function (id, blocks, parent) {
            if (!blocks) {
                return null;
            }
            let temp;
            for (let i = 0; i < blocks.length; i++) {
                temp = blocks[i];
                if (temp.Id == id || temp.id == id) {
                    return { index: i, blocks, parent };
                }
                const columns = Utilities.Config.getColumns(temp);
                if (columns) {
                    // Check each column in layout
                    let blockConfig;
                    for (let j = 0; j < columns.length; j++) {
                        // Check each block in column
                        blockConfig = Utilities.Config.findBlockConfig(id, columns[j], temp);
                        if (!blockConfig) {
                            continue;
                        }
                        return blockConfig;
                    }
                } else if (temp.config && temp.config.Block && temp.config.Block.design && temp.config.Block.design.Config && temp.config.Block.design.Config.blocks) {
                    // Check the design blocks
                    const blockConfig = Utilities.Config.findBlockConfig(id, temp.config.Block.design.Config.blocks, temp);
                    if (!blockConfig) {
                        continue;
                    }
                    return blockConfig;
                }
            }
            return null;
        },
        getBlockType: (block) => block.Type || block.type && block.type.value,
        getBodyStyle: function (config, props) {
            let style;
            if (props) {
                style = { ...props };
            }
            if (!config || !config.Styleguide) {
                return style;
            }
            if (!style) {
                style = {};
            }
            style.color = config.Styleguide.FontColor;
            if (config.Styleguide.BodyFont) {
                style.fontFamily = config.Styleguide.BodyFont.FontFamily;
            }
            return style;
        },
        getColumns: (block) => {
            switch (Utilities.Config.getBlockType(block)) {
                case Name.Block.Columns:
                    return block.blocks;
                case 'columnsFive':
                case 'columnsFour':
                case 'columnsSix':
                case 'columnsThree':
                case 'columnsTwo':
                case 'inventoryContainer':
                case 'itemContainer':
                case 'nonBreakingContainer':
                    return block.Columns;
            }
        },
        getDeepCopy: function (config) {
            if (typeof config !== "object" || config === null) {
                return config;
            }
            let copy = Array.isArray(config) ? [] : {}
            for (let key in config) {
                copy[key] = Utilities.Config.getDeepCopy(config[key]);
            }
            return copy;
        },
        getHeaderStyle: function (config, props) {
            let style;
            if (props) {
                style = { ...props };
            }
            if (!config || !config.Styleguide) {
                return style;
            }
            if (!style) {
                style = {};
            }
            style.color = config.Styleguide.HeaderColor;
            if (config.Styleguide.HeaderFont) {
                style.fontFamily = config.Styleguide.HeaderFont.FontFamily;
            }
            return style;
        },
        getMap: function (config, name) {
            const map = {};
            if (config && config[name]) {
                config[name].forEach(function (d) {
                    if (!d.name) {
                        return;
                    }
                    switch (d.type) {
                        case 'border':
                        case 'paddingMargin':
                            // Custom types that map to multiple properties
                            if (d.value) {
                                for (let id in d.value) {
                                    map[id] = d.value[id];
                                }
                            }
                            return;
                    }
                    map[d.name] = d.value;
                });
            }
            return map;
        },
        getStyle: function (data, configProps, type, props, prefix) {
            const _props = props || {};
            const _prefix = prefix || '';
            let style = {};
            let temp = configProps[`${_prefix}fontSize${type}`];
            if (!Utilities.isNullOrWhitespace(temp)) {
                style.fontSize = temp;
            }
            temp = configProps[`${_prefix}fontStyle${type}`];
            if (!Utilities.isNullOrWhitespace(temp)) {
                style.fontStyle = temp;
            }
            temp = configProps[`${_prefix}fontWeight${type}`];
            if (!Utilities.isNullOrWhitespace(temp)) {
                style.fontWeight = temp;
            }
            temp = configProps[`${_prefix}lineHeight${type}`];
            if (!Utilities.isNullOrWhitespace(temp)) {
                style.lineHeight = temp;
            }
            temp = configProps[`${_prefix}lineSpacing${type}`];
            if (!Utilities.isNullOrWhitespace(temp)) {
                style.marginBottom = temp;
            }
            temp = configProps[`${_prefix}textTransform${type}`];
            if (!Utilities.isNullOrWhitespace(temp)) {
                style.textTransform = temp;
            }
            for (let id in _props) {
                temp = _props[id];
                if (Utilities.isNullOrWhitespace(temp)) {
                    continue;
                }
                style[id] = temp;
            }
            if (configProps[`${_prefix}style${type}`] == 'header') {
                style = Utilities.Config.getHeaderStyle(data, style);
            } else {
                style = Utilities.Config.getBodyStyle(data, style);
            }
            temp = configProps[`${_prefix}color${type}`];
            if (!Utilities.isNullOrWhitespace(temp)) {
                style.color = temp;
            }
            return style;
        },
        getStyleV2: (configProps, props, handler) => {
            let style = {};
            let propValue;
            for (let propName in configProps) {
                propValue = configProps[propName];
                if (handler && handler(propName, propValue, style)) {
                    continue;
                }
                switch (propName) {
                    case 'design':
                    case 'displayText':
                    case 'style':
                    case 'renderOnlyFirst':
                        break;
                    case 'lineSpacing':
                        style.marginBottom = propValue;
                        if (propValue && propValue.value && propValue.unit) {
                            style.marginBottom = `${propValue.value}${propValue.unit}`;
                        }
                        break;
                    default:
                        if (propValue) {
                            if (propValue.value != undefined) {
                                if (propValue.value.length > 0) {
                                    style[propName] = `${propValue.value}${propValue.unit}`;
                                }
                            } else {
                                style[propName] = propValue;
                            }
                        }
                        break;
                }
            }
            if (props) {
                for (let id in props) {
                    propValue = props[id];
                    if (Utilities.isNullOrWhitespace(propValue)) {
                        continue;
                    }
                    style[id] = propValue;
                }
            }
            return style;
        },
        getVisibility: function (config, name) {
            let result = true;
            let visibility;
            if (config) {
                if (config.Config) {
                    visibility = config.Config.Visibility;
                } else if (config.config) {
                    visibility = config.config.Visibility;
                }
            }
            if (!visibility) {
                return result;
            }
            if (name) {
                result = visibility[name] != false;
            } else {
                for (let key in visibility) {
                    if (visibility[key] == false) {
                        return false;
                    }
                }
            }
            return result;
        },
        getVisibilityHash: function (config) {
            if (typeof config !== "object" || config === null) {
                return '';
            }
            let hash = '';
            let blockConfig, temp;
            for (let key in config) {
                temp = config[key];
                if (!temp) {
                    continue;
                }
                blockConfig = temp.Config || temp.config;
                if (blockConfig) {
                    if (blockConfig.Includes) {
                        for (let key in blockConfig.Includes) {
                            hash += blockConfig.Includes[key] == false ? '0' : '1';
                        }
                    }
                    if (blockConfig.Visibility) {
                        for (let key in blockConfig.Visibility) {
                            hash += blockConfig.Visibility[key] == false ? '0' : '1';
                        }
                    }
                }
                hash += Utilities.Config.getVisibilityHash(temp);
            }
            return hash;
        },
        updateStyleAlignment: (alignment, style) => {
            switch (alignment) {
                case 'tl':
                    style.textAlign = 'left';
                    style.verticalAlign = 'top';
                    break;
                case 'tc':
                    style.textAlign = 'center';
                    style.verticalAlign = 'top';
                    break;
                case 'tr':
                    style.textAlign = 'right';
                    style.verticalAlign = 'top';
                    break;
                case 'ml':
                    style.textAlign = 'left';
                    style.verticalAlign = 'middle';
                    break;
                case 'mc':
                    style.textAlign = 'center';
                    style.verticalAlign = 'middle';
                    break;
                case 'mr':
                    style.textAlign = 'right';
                    style.verticalAlign = 'middle';
                    break;
                case 'bl':
                    style.textAlign = 'left';
                    style.verticalAlign = 'bottom';
                    break;
                case 'bc':
                    style.textAlign = 'center';
                    style.verticalAlign = 'bottom';
                    break;
                case 'br':
                    style.textAlign = 'right';
                    style.verticalAlign = 'bottom';
                    break;
            }
        }
    },
    Format: {
        getDiscountString: (data, index, localization, options) => {
            if (!data.Discount && options) {
                return options.displayZero;
            }
            let format;
            switch (data.DiscountType) {
                case 1:
                    if (options) {
                        format = options.percentFormat;
                        if (index == 0 && options.percentFormatFirst && options.percentFormatFirst.length > 0) {
                            format = options.percentFormatFirst;
                        }
                    }
                    return Utilities.Format.Percent.getDisplayString(data.Discount, format);
                default:
                    if (options) {
                        format = options.format;
                        if (index == 0 && options.formatFirst && options.formatFirst.length > 0) {
                            format = options.formatFirst;
                        }
                    }
                    return Utilities.Format.Currency.getDisplayString(data.Discount, format, localization);
            }
        },
        Currency: {
            getDisplayString: function (value, formatString, localization) {
                if (!localization || isNaN(value)) {
                    return value;
                }
                let decimalPlaces = 0, groupSize = 0, shouldBreak;
                let prefix = '', numberSep = '', decimalSep = '', suffix = '';
                if (!Utilities.isNullOrWhitespace(formatString)) {
                    let processingPrefix = true, processingNumber = false, processingGroup = false, processingDecimal = false, processingSuffix = false;
                    const defaultCharHandler = function (c) {
                        if (processingPrefix) {
                            prefix += c;
                        } else if (processingNumber) {
                            numberSep += c;
                        } else if (processingGroup) {
                            decimalSep += c;
                        } else if (processingSuffix) {
                            suffix += c;
                        }
                    };
                    let i = 0, char;
                    while (i < formatString.length) {
                        char = formatString.charAt(i);
                        if (processingDecimal) {
                            if (char != '0') {
                                // Only count 0's after the decimal separator
                                processingDecimal = false;
                                processingSuffix = true;

                                // Let the character be processed again
                                continue;
                            } else {
                                decimalPlaces++;
                            }
                        } else {
                            let shouldBreak = false;
                            switch (char) {
                                case '0':
                                    if (processingGroup) {
                                        if (decimalSep.length == 0) {
                                            // Decimal separator hasn't been started => Increase group size
                                            groupSize++;
                                        } else {
                                            // Update decimal separator
                                            decimalSep += char;
                                        }
                                    } else if (!processingPrefix && !processingSuffix) {
                                        // Start parsing thousands group
                                        groupSize = 1;
                                        processingGroup = true;
                                        processingNumber = false;
                                        processingPrefix = false;
                                        shouldBreak = true;
                                    } else {
                                        defaultCharHandler(char);
                                    }
                                    break;
                                case '1':
                                    if (processingPrefix) {
                                        // Start parsing number
                                        processingNumber = true;
                                        processingPrefix = false;
                                    } else if (!processingNumber) {
                                        // Only process if not currently parsing number (consecutive 1's)
                                        defaultCharHandler(char);
                                    }
                                    break;
                                case '[':
                                    // Start parsing keyword
                                    let index = formatString.indexOf(']', i);
                                    if (index >= 0) {
                                        let keyword = formatString.substring(i + 1, index);
                                        switch (keyword) {
                                            case 'CurrencySymbol':
                                                defaultCharHandler(localization.CurrencySymbol);
                                                shouldBreak = true;
                                                break;
                                            case 'DecimalSep':
                                                decimalSep += localization.DecimalPoint;
                                                processingDecimal = true;
                                                processingGroup = false;
                                                processingNumber = false;
                                                processingPrefix = false;
                                                shouldBreak = true;
                                                break;
                                            case 'ThousandsSep':
                                                defaultCharHandler(localization.ThousandsSeparator);
                                                shouldBreak = true;
                                                break;
                                        }
                                        if (shouldBreak) {
                                            i = index;
                                            break;
                                        }
                                    }
                                default:
                                    defaultCharHandler(char);
                                    break;
                            }
                        }
                        i++;
                    }
                } else {
                    decimalPlaces = 2;
                    decimalSep = localization.DecimalPoint;
                    groupSize = 3;
                    numberSep = localization.ThousandsSeparator;

                    switch (localization.CurrencySymbolPlacement) {
                        case 1:
                            // Before
                            prefix = localization.CurrencySymbol;
                            break;
                        case 2:
                            // After
                            suffix = localization.CurrencySymbol;
                            break;
                    }
                }
                // Convert the value to the appropriate string representation
                let _value = value.toFixed(decimalPlaces);
                const isNegative = _value.charAt(0) == '-';
                if (isNegative) {
                    // Parse out the negative symbol
                    _value = _value.substring(1);
                }

                // Determine what part of the value should be displayed after the decimal separator content
                let index = _value.indexOf('.');
                let decimal = decimalSep;
                if (index > 0) {
                    decimal += _value.substring(index + 1);
                }

                let number = _value;
                if (index > 0) {
                    number = number.substring(0, index);
                } else {
                    index = number.length;
                }
                if (groupSize > 0) {
                    // Add the grouping separator where appropriate
                    let count = 0;
                    for (let i = index - 1; i > 0; i--) {
                        count++;
                        if (count % groupSize == 0) {
                            number = _value.substring(0, i) + numberSep + number.substring(i);
                        }
                    }
                }
                let formatted = number + decimal;
                if (isNegative) {
                    formatted = `(${formatted})`;
                }
                return prefix + formatted + suffix;
            },
            getFormatString: function (localization) {
                let value = '';
                if (!localization) {
                    return value;
                }
                if (localization.CurrencySymbolPlacement == 1) {
                    value += '[CurrencySymbol]';
                }
                value += '1[ThousandsSep]000[DecimalSep]00';
                if (localization.CurrencySymbolPlacement == 2) {
                    value += '[CurrencySymbol]';
                }
                return value;
            }
        },
        Percent: {
            getDefaultFormatString: function () {
                return '-[Value]%';
            },
            getDisplayString: function (value, formatString) {
                if (isNaN(value)) {
                    return value;
                }
                let prefix = '', suffix = '';
                if (!Utilities.isNullOrWhitespace(formatString)) {
                    let processingPrefix = true, processingSuffix = false;
                    let i = 0, char;
                    while (i < formatString.length) {
                        char = formatString.charAt(i);
                        if (char == '[') {
                            // Start parsing keyword
                            let index = formatString.indexOf(']', i);
                            if (index >= 0) {
                                let keyword = formatString.substring(i + 1, index);
                                if (keyword == 'Value') {
                                    processingPrefix = false;
                                    processingSuffix = true;

                                    i = index + 1;
                                    continue;
                                }
                            }
                        }
                        if (processingPrefix) {
                            prefix += char;
                        } else if (processingSuffix) {
                            suffix += char;
                        }
                        i++;
                    }
                } else {
                    prefix = '-';
                    suffix = '%';
                }
                let _value = value.toString();
                if (_value.charAt(0) == '-') {
                    // Parse out the negative symbol
                    _value = _value.substring(1);
                }
                return prefix + _value + suffix;
            }
        }
    },
    Inventory: {
        _getEditionComponents: function (data) {
            if (!data || data.Type != 0) {
                return;
            }
            let count = '';
            let number = '';
            if (data.EditionCount) {
                count = data.EditionCount;
            }
            if (data.EditionNumber) {
                number = data.EditionNumber;
            }
            return { count: count, number: number };
        },
        getEditionFormatString: (type) => {
            switch (type) {
                case 'limited':
                    return ' ([EditionNumber]/[EditionCount])';
                case 'unlimited':
                    return ' (Edition [EditionNumber])';
            }
            return '[EditionNumber]';
        },
        getEditionNumber: function (data) {
            const components = Utilities.Inventory._getEditionComponents(data);
            if (!components) {
                return;
            }
            let editionNumber;
            switch (data.EditionType) {
                case 1:
                    if (components.count.length > 0 || components.number.length > 0) {
                        editionNumber = `${components.number}/${components.count}`;
                    }
                    break;
                case 2:
                    editionNumber = `Edition ${components.number}`;
                    break;
            }
            return editionNumber;
        },
        getEditionNumberV2: (data) => {
            const components = Utilities.Inventory._getEditionComponents(data);
            if (!components) {
                return;
            }
            let editionNumber;
            switch (data.EditionType) {
                case 1:
                    if (components.count.length > 0 || components.number.length > 0) {
                        editionNumber = `${components.number}/${components.count}`;
                    }
                    break;
                case 2:
                    editionNumber = `${components.number}`;
                    break;
            }
            return editionNumber;
        },
        getEditionNumberWithFormat: function (data, formatLimited, formatUnlimited) {
            const components = Utilities.Inventory._getEditionComponents(data);
            if (!components) {
                return;
            }
            switch (data.EditionType) {
                case 1:
                    if (formatLimited) {
                        return formatLimited.replace('[EditionNumber]', components.number).replace('[EditionCount]', components.count);
                    }
                    break;
                case 2:
                    if (formatUnlimited) {
                        return formatUnlimited.replace('[EditionNumber]', components.number);
                    }
                    break;
            }
        },
        getRecords: (props) => {
            const data = props.data || {};
            let inventory = data.Inventory;
            if (inventory) {
                if (props.builder && inventory.length > 5) {
                    inventory = inventory.slice(0, 5);
                } else if (props.preview && inventory.length > 100) {
                    inventory = inventory.slice(0, 100);
                }
            }
            return inventory;
        },
        getSubtitle: function (data, includeEdition, includeDate) {
            let subtitle;
            if (!data) {
                return subtitle;
            }
            if (includeEdition == true) {
                const editionNumber = Utilities.Inventory.getEditionNumber(data);
                if (!Utilities.isNullOrWhitespace(editionNumber)) {
                    subtitle = ` (${editionNumber})`;
                }
            }
            if (includeDate == true && !Utilities.isNullOrWhitespace(data.Date)) {
                if (!subtitle) {
                    subtitle = '';
                }
                subtitle += `, ${data.Date}`;
            }

            return subtitle;
        }
    },

    _removeHTMLTagFromContent: (content, tag) => {
        let _content = content.replaceAll(`</${tag}>`, '');
        const _tag = `<${tag}`;
        let index = _content.indexOf(_tag);
        let end;
        while (index >= 0) {
            end = _content.indexOf('>', index);
            if (index < 0) {
                break;
            }
            _content = _content.substring(0, index) + _content.substring(end + 1);
            index = _content.indexOf(_tag);
        }
        return _content;
    },
    extractStyle: (design, elementType) => {
        let value = design;
        if (!value || !value.indexOf) {
            return;
        }
        value = value.replace(' class="custom-color"', '');
        let elementStyle = '';
        let testString = `<p class="${elementType}" style="`;
        let index = value.indexOf(testString);
        if (index >= 0) {
            // Parent style (e.g. text align)
            let _value = value.substring(index + testString.length);
            testString = '"';
            index = _value.indexOf(testString);
            if (index >= 0) {
                elementStyle = _value.substring(0, index);
            }
        }
        testString = '<span style="';
        index = value.indexOf(testString);
        if (index < 0) {
            return elementStyle;
        }
        value = value.substring(index + testString.length);
        testString = '"';
        index = value.indexOf(testString);
        if (index < 0) {
            return elementStyle;
        }
        elementStyle += value.substring(0, index);
        return elementStyle;
    },
    generateUniqueId: () => (Math.random() * (new Date().getTime())).toString().replace('.', '_'),
    getHTMLContent: (content) => {
        if (Utilities.isNullOrWhitespace(content)) {
            return content;
        }
        let _content = Utilities._removeHTMLTagFromContent(content, 'p');
        _content = Utilities._removeHTMLTagFromContent(_content, 'span');
        _content = _content.replaceAll('&nbsp;', '');
        return _content;
    },
    isHTMLContentEmpty: (content) => Utilities.isNullOrWhitespace(Utilities.getHTMLContent(content)),
    isNullOrWhitespace: (value) => {
        if (!value) {
            return true;
        }
        return value.toString().trim().length == 0
    },
    wrapTextForEditor: ({ tag = 'p', tagExtras, text, textExtras, token, wrapWithTag }) => {
        let wrappedText = `<span${textExtras ? ` ${textExtras}` : ''}${token ? ` token="${token}"` : ''} data-heading="${tag}">${text || ''}</span>`;
        if (wrapWithTag != false) {
            wrappedText = `<p class="${tag}"${tagExtras ? ` ${tagExtras}` : ''}>${wrappedText}</p>`
        }
        return wrappedText;
    },
}

Utilities.Builder = {
    dragOutline: () => <div className="drag-outline" />,
    emptyBlockPlaceholder: (minHeight) => <div style={{ minHeight: minHeight || '18px' }} />
}

// Polyfills

if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (str, newStr) {
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
        }
        return this.replace(new RegExp(str, 'g'), newStr);
    };
}

module.exports = Utilities;